import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, Store } from 'lucide-react';
import { Reveal } from '../motion';

const FinalCta = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section data-testid="final-cta-section" className="relative bg-white dark:bg-gray-950 py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="relative overflow-hidden rounded-[2rem] border border-gray-200/80 dark:border-white/10 bg-gradient-to-br from-blue-600 via-blue-600 to-emerald-500 px-6 py-14 sm:px-12 sm:py-16 grain">
          <span className="aurora-blob w-[22rem] h-[22rem] -top-24 end-[-4rem] bg-white/30 animate-aurora" />
          <span className="aurora-blob w-[18rem] h-[18rem] bottom-[-6rem] start-[-3rem] bg-teal-200/40 animate-aurora-slow" />

          <div className="relative max-w-2xl">
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              {t('landing.finalTitle', 'Start booking today')}
            </h2>
            <p className="mt-4 text-base sm:text-lg text-white/80">
              {t('cta.subtitle', 'Join thousands of satisfied users who trust EnayaHub for their health and beauty needs')}
            </p>
            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => navigate('/healthcare-providers')}
                data-testid="final-cta-find-providers"
                className="btn-shine group inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-4 text-sm font-bold text-blue-700 shadow-xl lift"
              >
                {t('findProviders', 'Find Providers')}
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 rtl:rotate-180" />
              </button>
              <button
                onClick={() => navigate('/pricing')}
                data-testid="final-cta-for-providers"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-7 py-4 text-sm font-bold text-white backdrop-blur-sm lift hover:bg-white/20"
              >
                <Store className="w-4 h-4" />
                {t('siteNav.forProviders', 'For Providers')}
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCta;
